import React, { useContext } from "react";
import { DataTable, QueryResult, Table, ValueOrPlaceholder } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { expandedRowsUpdated, focusedRowUpdated, selectExpandedRow, selectFocusedRow, } from "../../../store/licensesSlice";
import { ExpandedRowDetails, LicenseText } from "../../../ui";
import { AuditCell, IssuesList } from "../../common";
import { ReportContext } from "../../context";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useGetLicenseDetailsQuery } from "../../services/licenses.api";
import LicenseNoticeAudit from "./LicenseNoticeAudit";
import LicenseReferences from "./LicenseReferences";
const LicenseDetails = ({ licenseInfo, index, }) => {
    var _a;
    const { reportId } = useContext(ReportContext);
    const dispatch = useReportDispatch();
    const expanded = useReportSelector((state) => selectExpandedRow(state, licenseInfo.spdx_id));
    const focusedRow = useReportSelector(selectFocusedRow);
    const { data: licenseDetailsData, isFetching, isLoading, isError, error, } = useGetLicenseDetailsQuery({
        ui_item_id: licenseInfo.spdx_id,
        ui_id: reportId,
    }, { skip: !expanded });
    return (React.createElement(DataTable.ExpandedRow, { id: `license-expand-row-${index}`, expanded: expanded, onChange: (isExpanded) => dispatch(expandedRowsUpdated({ id: licenseInfo.spdx_id, expand: isExpanded })), focused: focusedRow === licenseInfo.spdx_id, onClick: () => dispatch(focusedRowUpdated(licenseInfo.spdx_id)) },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null, licenseInfo.spdx_id),
            React.createElement(Table.Cell, null, licenseInfo.family),
            React.createElement(Table.Cell, null,
                React.createElement(ValueOrPlaceholder, { value: licenseInfo.violations.length })),
            React.createElement(Table.Cell, null, licenseInfo.references_count.toLocaleString()),
            React.createElement(Table.Cell, null,
                React.createElement(AuditCell, { audit: licenseInfo.audit }))),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(ExpandedRowDetails, null,
                React.createElement(ExpandedRowDetails.Aside, null,
                    React.createElement(QueryResult, { status: getQueryStatus({
                            data: licenseDetailsData,
                            isLoading,
                            isFetching,
                            isError,
                            error,
                        }) },
                        React.createElement(LicenseNoticeAudit, { license: licenseInfo }),
                        React.createElement(IssuesList, { violations: licenseInfo.violations, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE }))),
                React.createElement(ExpandedRowDetails.Main, null,
                    React.createElement(LicenseText, { licenseText: (_a = licenseDetailsData === null || licenseDetailsData === void 0 ? void 0 : licenseDetailsData.text) !== null && _a !== void 0 ? _a : "", fileName: licenseInfo.spdx_id }),
                    React.createElement(LicenseReferences, { reportId: reportId, licenseId: licenseInfo.spdx_id }))))));
};
export default LicenseDetails;
//# sourceMappingURL=LicenseDetails.js.map